function u(r) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = r(n)), t[n];
  };
}
export {
  u as default
};
//# sourceMappingURL=index.es134.js.map
